/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombOfNefertitiServerDataParser} from "../TombOfNefertitiServerDataParser";
import {ITombOfNefertitiInitData} from "./ITombOfNefertitiServerData";
import {TombOfNefertitiGameMode} from "../../gamemode/TombOfNefertitiGameMode";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";

export class TombOfNefertitiParsedInitData extends ParsedInitData {
    private readonly _respinPositionsAfter: boolean[] = [];
    private readonly _currentGameMode: string;
    private readonly _nextGameMode: string;
    private readonly _respinPlayed: number;
    private readonly _totalRespinWin: number;

    constructor(rawData: ITombOfNefertitiInitData, dataParser: TombOfNefertitiServerDataParser) {
        super(rawData, dataParser);

        this._respinPositionsAfter = dataParser.parseRespinPositionsAfter(rawData);
        this._payoutWinMultiplier = dataParser.parsePayoutMultiplier(rawData);

        this._currentGameMode = dataParser.parseCurrentGameMode(rawData);
        this._nextGameMode = dataParser.parseNextGameMode(rawData);
        this._respinPlayed = dataParser.parseRespinPlayed(rawData);
        this._totalRespinWin = dataParser.parseTotalRespinWin(rawData);

        this._indexesForAttention = [];
        this._indexBeforeAttention = -1;

        this.checkUsableFont();
    }

    private checkUsableFont():void{
        let slotApi: any = SlotGame.api;
        if(slotApi.options.language !== "en"){
            TombOfNefertitiGameConfig.instance.USABLE_FONT = 'Verdana';
        }
    }

    public get totalRespinWin(): number {
        return this._totalRespinWin;
    }

    public get respinPlayed(): number {
        return this._respinPlayed;
    }

    public get respinPositions(): boolean[] {
        return this._respinPositionsAfter;
    }

    private _payoutWinMultiplier: number;

    public get payoutWinMultiplier(): number {
        return this._payoutWinMultiplier;
    }

    private _indexBeforeAttention: number;

    get indexBeforeAttention(): number {
        return this._indexBeforeAttention;
    }

    private _indexesForAttention: number[];

    get indexesForAttention(): number[] {
        return this._indexesForAttention;
    }

    protected isFeatureTotalWin(): boolean {
        return (this.mode === TombOfNefertitiGameMode.RESPIN || this.mode === TombOfNefertitiGameMode.RESPIN_FREESPIN);
    }

    protected isNextFeatureTotalWin(): boolean {
        return (this.nextMode === TombOfNefertitiGameMode.RESPIN || this.nextMode === TombOfNefertitiGameMode.RESPIN_FREESPIN);
    }
}